import { useAppVersion } from '../hooks/useAppVersion';
import { RefreshCw, X } from 'lucide-react';

export function UpdateNotification() {
  const { isUpdateAvailable, forceRefresh } = useAppVersion();

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 bg-blue-600 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-3 animate-pulse">
      <RefreshCw className="w-5 h-5 animate-spin" />
      <div>
        <p className="font-medium">Update Available</p>
        <p className="text-sm opacity-90">A new version is ready</p>
      </div>
      <button
        onClick={forceRefresh}
        className="bg-white text-blue-600 px-3 py-1 rounded text-sm font-medium hover:bg-blue-50 transition-colors"
      >
        Update Now
      </button>
      <button
        onClick={() => window.location.reload()}
        className="text-white hover:text-blue-100 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
